import React from 'react';

import ProjectDesktopImage from '../../../../components/project/project-desktop-image';
import ProjectLogoWork from '../../../../components/project/project-logo-work';
import ProjectSliderAnimation from '../../../../components/project/project-slider/project-slider-animation';
import ProjectQuote from '../../../../components/project/project-quote';
import ProjectVideo from '../../../../components/project/project-video';
import ProjectVideoAds from '../../../../components/project/project-video-ads';
import ProjectBrandedMaterials from '../../../../components/project/project-branded-materials';
import ProjectInteriorPages from '../../../../components/project/project-interior-pages';
import ProjectAdStills from '../../../../components/project/project-ad-stills';

const ADCaseStudy = ({ slug, acf }) => {
  return (
    <React.Fragment>
      <ProjectLogoWork
        slug={slug}
        color={acf.logo_work_color}
        blurb={acf.logo_work_blurb}
        wrapperPadding={'0 0 10vw 0'}
      />
      <ProjectDesktopImage
        desktopImage={acf.desktop_design}
        backgroundColor={acf.desktop_image_background}
        blurb={acf.desktop_design_blurb}
        wrapperPadding={'3rem'}
      />
      <ProjectInteriorPages
        images={acf.interior_pages}
        blurb={acf.interior_pages_blurb}
        wrapperPadding={'10vw 0 10vw 0'}
      />
      <ProjectBrandedMaterials
        image={acf.branded_materials_image}
        blurb={acf.branded_materials_blurb}
        wrapperPadding={'0'}
      />
      <ProjectSliderAnimation
        slides={acf.slider}
        blurb={acf.slider_blurb}
        wrapperPadding={[
          'calc(10vw - 14px) 10vw 5vw 10vw',
          'calc(10vw - 14px) 0 5vw 0',
        ]}
      />
      <ProjectVideo
        videoId={acf.video_id}
        videoThumbnail={acf.video_thumbnail}
        blurb={acf.video_blurb}
        wrapperPadding={'5vw 0 10vw 0'}
      />
      <ProjectAdStills stills={acf.ad_stills} blurb={acf.ad_stills_blurb} />
      <ProjectQuote
        quote={acf.quote}
        name={acf.quote_name}
        title={acf.quote_title}
      />
    </React.Fragment>
  );
};

export default ADCaseStudy;



// WEBPACK FOOTER //
// ./src/templates/project/case-studies/ad/index.js